import Index from '@tunnel-components/@pages/supervision/camera/statistics/container';

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/statistics/index.ts